import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';

import configureStore from 'config/store/configureStore';
import MyIntlProvider from 'config/MyIntlProvider';

import { getApi } from 'modules/api';
import {loginVerify} from 'modules/auth';

import {getQueryParams} from 'util/router';

import App from 'App.jsx';

require('babel-polyfill');
const store = configureStore();
const messages = {
    en: require('locales/en'),
    es: require('locales/es')
};
const formats = require('config/formats');

getApi().syncReduxAndApi(store);

addLocaleData(en);
addLocaleData(es);

const params = getQueryParams(window.location.search);

if (Object.keys(params).includes('code')) {
    window.location.href = `${window.location.protocol}//${window.location.host}/#/sso-cloudglass/${window.location.search}`;
} else {
    store.dispatch(loginVerify());

    ReactDOM.render(
        <Provider store={store}>
            <MyIntlProvider messages={messages} formats={formats}>
                <App />
            </MyIntlProvider>
        </Provider>, document.getElementById('root'));

    if (navigator && navigator.serviceWorker) {
        navigator.serviceWorker.getRegistrations().then(registrations => {
            for (const registration of registrations) {
                registration.unregister();
            }
        });
    }
}




// WEBPACK FOOTER //
// ./src/index.js